export default "__VITE_ASSET__68cc549e__"